import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { VariableModel } from "../../models/VariableModel";
import { makeMentionsSelector } from "../../redux/selectors/mentions";

const enforceOpenEndKey = "EnforceOpenEnd";
const errorKey = "IncompleteAnswer";

export default function openEndRequired(variable: VariableModel) {
    const { name: variableName, choiceList } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const mentions = mentionsSelector(getState());

        const hasInvalidMentions = mentions
            .filter((mention) => mention.openEnd === undefined || !mention.openEnd.trim().length)
            .map((mention) => choiceList.find((choice) => choice.value === mention.value))
            .some((choice) => choice && choice.settings[enforceOpenEndKey] === true);

        // TODO: Temporary fix for soft-prompt compatibility with the question types that
        // haven't had their validation redesign.
        const args = { openEnd: variableName };

        if (hasInvalidMentions) {
            return { variableName, error: { key: errorKey, args } };
        }

        return null;
    };
}
